<template>
  <div class="container-fluid main-color">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Assessment Timeline Detail</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <place-holder v-if="loading"></place-holder>
        <div class="card">
          <div v-if="!loading && assessmentDetail" class="card-body">
            <form class="parsley-examples">
              <!-- Employee Information Row -->
              <div class="row mb-3 mt-2">
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Employee Name</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control" :value="assessmentDetail.enrolled_user?.name || '-'"
                        disabled />
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Employee ID</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control"
                        :value="assessmentDetail.enrolled_user?.employee_id || assessmentDetail.enrolled_user_id || '-'"
                        disabled />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Training Information Row -->
              <div class="row mb-3">
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Training Plan</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control" :value="assessmentDetail.monthly_plan?.name || '-'"
                        disabled />
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Module</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control"
                        :value="assessmentDetail.monthly_plan?.module?.name || '-'" disabled />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Training Date & Expire Date Row -->
              <div class="row mb-3">
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Training Date</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control" :value="assessmentDetail.monthly_plan?.from_date"
                        disabled />
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Expire Date</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control" :value="assessmentDetail.expire_date" disabled />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Status & Total Score Row -->
              <div class="row mb-3">
                <!-- HR Selection Row -->
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Related HR</label>
                    </div>
                    <div class="col-7">
                      <v-select v-model="hr" label="name" :options="employees" :clearable="false"
                        :loading="!employees.length" :class="{ 'is-invalid': errors.hr }"
                        :reduce="employee => employee">
                        <template #option="{ name, employee_id }">
                          {{ name }}
                        </template>
                        <template #selected-option="{ name, employee_id }">
                          {{ name }}
                        </template>
                      </v-select>
                      <div v-if="errors.hr" class="text-danger mt-1">
                        {{ errors.hr }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Total Score</label>
                    </div>
                    <div class="col-7">
                      <input type="text" class="form-control"
                        :value="assessmentDetail.total !== null ? assessmentDetail.total : 'Not scored yet'" disabled />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Supervisor Selection Row -->
              <div class="row mb-3">
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Superior</label>
                    </div>
                    <div class="col-7">
                      <v-select v-model="supervisor" label="name" :options="employees" :clearable="false"
                        :loading="!employees.length" :class="{ 'is-invalid': errors.supervisor }"
                        :reduce="employee => employee">
                        <template #option="{ name, employee_id }">
                          {{ name }}
                        </template>
                        <template #selected-option="{ name, employee_id }">
                          {{ name }}
                        </template>
                      </v-select>
                      <div v-if="errors.supervisor" class="text-danger mt-1">
                        {{ errors.supervisor }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-3">
                      <label for="" class="h5">Status</label>
                    </div>
                    <div class="col-7">
                      <select v-model="selectedStatus" :disabled="!canChangeStatus" class="form-control"
                        :class="{ 'is-invalid': errors.status }">
                        <option v-for="status in statusOptions" :value="status.value" :key="status.value"
                          :disabled="status.disabled">
                          {{ status.text }}
                        </option>
                      </select>
                      <div v-if="errors.status" class="text-danger mt-1">
                        {{ errors.status }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Questions & Answers Section -->
              <div class="row mt-4">
                <div class="col-12">

                  <div v-if="questionsList.length > 0">
                    <div v-for="(question, index) in questionsList" :key="question.id" class="mb-1">
                      <div class="row">
                        <div class="col-12">
                          <div class="">
                            <div class="">
                              <h5 class="mb-3">{{ index + 1 }}. {{ question.question }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Radio Type Questions -->
                      <div v-if="question.type === 'radio'" class="row">
                        <div class="col-12">
                          <div class="row">
                            <div v-for="option in question.attributes || []" :key="option.id" class="col-12 mb-2">
                              <div class="d-flex align-items-center">
                                <input class="form-check-input" type="radio" :name="'question_' + question.id"
                                  :value="option.id" :checked="question.answer == option.id" disabled>
                                <label class="form-check ms-1" :class="{ '': question.answer == option.id }">
                                  {{ option.name }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col-12">
                          <p class="form-control" rows="4" disabled>
                            ..
                          </p>
                        </div>
                      </div>
                      <hr>
                    </div>
                  </div>
                  <div v-else class="alert alert-info">
                    <i class="mdi mdi-information-outline me-2"></i>
                    No questions available for this module.
                  </div>
                </div>
              </div>

              <div class="">
                <div class="col-12">
                  <label class="form-label h5">Please, provide your feedback and suggestions for further improvement of
                    this
                    training.</label>
                  <div class="card bg-light">
                    <div class="card-body">
                      <p class="mb-0">User hasn't provide Suggestion yet!</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="row mt-4">
                <div class="col-12">
                  <div class="text-center">
                    <!-- Cancel Button -->
                    <button type="button" class="btn btn-secondary me-3"
                      @click="$router.push({ name: 'after-month-assessment-timeline' })">
                      Cancel
                    </button>

                    <!-- Resend Button (ONLY if expire date > today) -->
                    <button v-if="canResend && hasPermissions(['self-assessment-resend-form'])"
                      class="btn btn-warning me-3 px-3" @click="resendAssessment" :disabled="loading">
                      <i class="mdi mdi-email-send-outline me-1"></i>
                      Resend Assessment
                    </button>

                    <!-- Update Assignee Button -->
                    <button v-if="hasPermissions(['self-assessment-status-update'])" type="button"
                      class="btn btn-success px-3" @click="updateTimeline" :disabled="updateLoading">
                      <span v-if="updateLoading" class="spinner-border spinner-border-sm me-1"></span>
                      {{ updateLoading ? "Loading..." : "Save" }}
                    </button>

                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="card-body text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <!-- Not Found State -->
          <div v-if="!loading && !assessmentDetail" class="card-body text-center py-5">
            <div class="alert alert-warning">
              <h5>Assessment not found</h5>
              <p>The assessment you're looking for does not exist.</p>
              <button class="btn btn-primary" @click="$router.push({ name: 'after-month-assessment-timeline' })">
                Back to List
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useToast } from "vue-toastification";
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  components: {
    vSelect,
  },
  mixins: [userHasPermissions],
  data() {
    return {
      assessmentDetail: null,
      employees: [],
      supervisor: null,
      hr: null,
      loading: false,
      updateLoading: false,
      statusUpdating: false,
      selectedStatus: null,
      errors: {
        supervisor: null,
        hr: null,
        status: null
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  computed: {
    questionsList() {
      if (!this.assessmentDetail) return [];

      const questions = this.assessmentDetail.monthly_plan?.module?.self_assessment_questions || [];

      return questions.map(question => ({
        ...question,
        answer: question.answer || null
      }));
    },

    canResend() {
      if (parseInt(this.assessmentDetail?.status) === 2) return false;
      if (parseInt(this.assessmentDetail?.status) === 1) return false;
      if (!this.assessmentDetail?.expire_date) return false;
      if (this.assessmentDetail.resend === 1) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const expireDate = new Date(this.assessmentDetail.expire_date);
      expireDate.setHours(0, 0, 0, 0);

      return expireDate < today;
    },

    // Can change status only if current status is 0 (waiting) or 3 (cancel)
    canChangeStatus() {
      if (!this.assessmentDetail) return false;
      if (!this.hasPermissions(['self-assessment-status-update'])) return false;

      const currentStatus = parseInt(this.assessmentDetail.status);
      return [0, 3, 4].includes(currentStatus);
    },

    // Status options with disabled states
    statusOptions() {
      const currentStatus = parseInt(this.assessmentDetail?.status);

      const editable = [0, 3, 4].includes(currentStatus);

      return [
        { value: 0, text: 'Waiting', disabled: !editable },
        { value: 1, text: 'On Progress', disabled: true },
        { value: 2, text: 'Complete', disabled: true },
        { value: 3, text: 'Cancel', disabled: !editable },
        { value: 4, text: 'Draft', disabled: !editable },
      ];
    }
  },
  methods: {
    getOptionName(options, answerId) {
      if (!options || !answerId) return '';
      const option = options.find(opt => opt.id == answerId);
      return option ? option.name : 'Unknown';
    },

    async resendAssessment() {
      try {
        this.loading = true;
        await axios.put(
          `${this.baseUrl}admin/v2/self-assessment-resend/${this.assessmentDetail.id}`,
          {
            action: 'resend'
          }
        );
        this.toast.success("Assessment has been resent successfully.");
        await this.fetchAssessmentDetail();
      } catch (error) {
        console.error("Resend failed:", error);
        this.toast.error("Failed to resend assessment.");
      } finally {
        this.loading = false;
      }
    },

    getStatusText(status) {
      switch (parseInt(status)) {
        case 0:
          return 'Waiting';
        case 1:
          return 'Pending';
        case 2:
          return 'Complete';
        case 3:
          return 'Cancel';
        default:
          return 'Unknown';
      }
    },

    getStatusClass(status) {
      switch (parseInt(status)) {
        case 0:
          return 'badge-warning';
        case 1:
          return 'badge-info';
        case 2:
          return 'badge-success';
        case 3:
          return 'badge-danger';
        default:
          return 'badge-secondary';
      }
    },

    getQuestionTypeClass(type) {
      switch (type) {
        case 'radio':
          return 'bg-primary';
        case 'typing':
          return 'bg-success';
        default:
          return 'bg-secondary';
      }
    },

    onSupervisorChange(selected) {
      this.errors.supervisor = null;
    },

    onHrChange(selected) {
      this.errors.hr = null;
    },

    async updateTimeline() {
      const payload = {}

      if (this.selectedStatus !== this.assessmentDetail.status) {
        payload.status = this.selectedStatus
      }

      if (this.supervisor?.employee_id) {
        payload.supervisor_id = this.supervisor.employee_id
      }

      if (this.hr?.employee_id) {
        payload.hr_id = this.hr.employee_id
      }

      if (!Object.keys(payload).length) {
        this.toast.info("No changes detected.")
        return
      }

      this.updateLoading = true
      this.errors = { supervisor: null, hr: null, status: null }

      try {
        await axios.put(
          `${this.baseUrl}admin/v2/self-assessment/timeline-update/${this.$route.params.id}`,
          payload
        )

        this.toast.success("Assessment updated successfully!")
        await this.fetchAssessmentDetail()

      } catch (error) {
        const res = error.response

        if (res?.status === 422) {
          const errs = res.data.errors || {}
          this.errors.supervisor = errs.supervisor_id?.[0] || null
          this.errors.hr = errs.hr_id?.[0] || null
          this.errors.status = errs.status?.[0] || null
        } else {
          this.toast.error(res?.data?.message || "Update failed.")
        }
      } finally {
        this.updateLoading = false
      }
    },


    async fetchAssessmentDetail() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${this.baseUrl}admin/v2/self-assessment/${this.$route.params.id}`
        );

        this.assessmentDetail = response.data.data;
        console.log(this.assessmentDetail);

        // Set the selected status from assessment data
        this.selectedStatus = this.assessmentDetail.status;

        // Wait for employees to load if needed
        if (this.employees.length === 0) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        // Set current supervisor
        if (this.assessmentDetail.supervisor) {
          const supervisorId = this.assessmentDetail.supervisor.employee_id;
          const supervisorName = this.assessmentDetail.supervisor.name;

          let supervisorObj = this.employees.find(emp =>
            emp.employee_id === supervisorId || emp.name === supervisorName
          );

          if (!supervisorObj) {
            supervisorObj = {
              name: supervisorName,
              employee_id: supervisorId
            };
            this.employees.push(supervisorObj);
          }

          this.supervisor = supervisorObj;
        }

        // Set current HR
        if (this.assessmentDetail.hr) {
          const hrId = this.assessmentDetail.hr.employee_id;
          const hrName = this.assessmentDetail.hr.name;

          let hrObj = this.employees.find(emp =>
            emp.employee_id === hrId || emp.name === hrName
          );

          if (!hrObj) {
            hrObj = {
              name: hrName,
              employee_id: hrId
            };
            this.employees.push(hrObj);
          }

          this.hr = hrObj;
          console.log("Set HR:", this.hr);
        }

      } catch (error) {
        console.error('Error fetching assessment detail:', error);
        this.toast.error("Failed to load assessment details.");
      } finally {
        this.loading = false;
      }
    },

    // Fetch employees from store
    fetchEmployees() {
      let intervalId;
      let attemptCount = 0;
      const maxAttempts = 30;

      if (!this.employees.length) {
        intervalId = setInterval(() => {
          attemptCount++;

          const employeesData = this.$store.getters["odoo/getAllEmployees"];

          if (employeesData && Array.isArray(employeesData) && employeesData.length > 0) {
            this.employees = employeesData.map(emp => ({
              name: emp.name || emp.employee_name || '',
              employee_id: emp.employee_id || emp.emp_id || emp.id || '',
              ...emp
            })).filter(emp => emp.name && emp.employee_id);

            clearInterval(intervalId);
          }

          if (attemptCount >= maxAttempts) {
            console.error("Failed to load employees after", maxAttempts, "attempts");
            clearInterval(intervalId);
          }
        }, 1000);
      }
    },
  },
  created() {
    this.fetchAssessmentDetail();
    this.fetchEmployees();
  },
};
</script>

<style scoped>
.form-check-input:disabled {
  opacity: 1;
}
</style>